<div class="bg-toast-overlay" [hidden]="!(toastMessageService && toastMessageService.isShown)" (click)="toastMessageService.off()">
    <div class="bg-toast-text">
        <div class="icon" [hidden]="!toastMessageService.isIconShown">
            <i class="shape {{ toastMessageService.iconClass }}"></i>
        </div>
        <p class="message">{{ toastMessageService.message }}</p>
    </div>
</div>
